export enum PhoneNameId {
  ID = 'id',
  COUNTRY_CODE = 'countryCode',
  PHONE_NUMBER = 'phoneNumber',
  HAS_WHATSAPP = "hasWhatsapp",
  HAS_TELEGRAM = "hasTelegram",
  IS_VERIFIED = "isVerified",
  CREATED_AT = 'createdAt',
}
